import { BrowserRouter } from 'react-router-dom'
import { AuthProvider } from './core/context/AuthContext'
import Routes from './routes'
import { ThemeProvider } from '@mui/material'
import theme from './layouts/Theme'
import './App.css'
import { ToastProvider } from './core/context/ToastContext'

function App() {
  return (
    <ThemeProvider theme={theme}>
      <BrowserRouter>
        <ToastProvider>
          <AuthProvider>
            <Routes />
          </AuthProvider>
        </ToastProvider>
      </BrowserRouter>
    </ThemeProvider>
  )
}

export default App
